import React from 'react';
import { render } from 'react-dom';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import App from '@tportal/login/App';
import i18n from '@tportal/login/i18n';

const node = document.getElementById('login_main') as HTMLElement;
const data = JSON.parse(node.getAttribute('data') as string);

const locale: string = data.i18n;

i18n.changeLanguage(locale);

const history = createBrowserHistory({ forceRefresh: true });

render(
  <Router history={history}>
    <App
      logoUrl={data.logo_url ?? ''}
      selfSignupEnabled={data.self_signup_enabled}
      email={data.email ?? ''}
      isHOA={data.is_hoa}
      pmInfo={data.pm_info}
    />
  </Router>,
  node
);

if (module.hot) {
  module.hot.accept();
}
